export const ServiceTypeEnum = { Inspector: 1 };
